import { render } from "./SimpleInvoice.vue?vue&type=template&id=7b475851&scoped=true&ts=true"
import script from "./SimpleInvoice.vue?vue&type=script&lang=ts"
export * from "./SimpleInvoice.vue?vue&type=script&lang=ts"

import "./SimpleInvoice.vue?vue&type=style&index=0&id=7b475851&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b475851"]])

export default __exports__